import { useState } from 'react';
import Button from '@mui/joy/Button';
import Stack from '@mui/joy/Stack';

import getIcon from 'utils/getIcon';

export function sc(id: string, behavior: ScrollBehavior = "smooth") {
    document.getElementById(id)?.scrollIntoView({ behavior: behavior });
}


const Next = ({ nextId, ks = "Keep Scrolling", onClick = undefined }: { nextId: string, ks?: string | undefined, onClick?: () => void }) => {
    const DownIcon = getIcon('ArrowDownward');
    const [showing, setShowing] = useState(true);
    function hideForSec() {
        setShowing(false);
        setTimeout(() => {
            setShowing(true);
        }, 1_000);
    }
    return (
        <Stack sx={{
            opacity: showing ? 1 : 0,
            transition: "all ease-in-out 0.4s",
            position: "absolute",
            padding: 1,
            bottom: "2dvh",
            left: 0,
            direction: "row",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
        }} >

            <Button
                variant={showing ? 'plain' : 'soft'}
                color={showing ? 'primary' : 'neutral'}
                onClick={() => { sc(nextId); hideForSec(); onClick && onClick(); }}
                endDecorator={<DownIcon />}>{ks}</Button>

        </Stack>
    )
};

export default Next;
